module.exports = __webpack_public_path__ + "static/img/7.9ace520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/7.jpg
// module id = 5lbB
// module chunks = 1